export default {
  accountChangeAplly: "Мэдээлэл шинэчлэх хүсэлт илгээх",
  accouuntAppliedBankList: "Бүртгэлтэй дансны жагсаалт",
  accountBankType: "Дансны төрөл",
  accountTradePaymentBankInfo: "Төлбөр шилжүүлэх дансны мэдээлэл"
};
